import React, { createContext, useContext, useState, useEffect } from 'react';
import { DEFAULT_IDE, IDE_STORAGE_KEY } from '../config/constants';

const IdeContext = createContext();

export function IdeProvider({ children }) {
  const [selectedIde, setSelectedIde] = useState(() => {
    // Initialize from localStorage or use default
    const saved = localStorage.getItem(IDE_STORAGE_KEY);
    return saved || DEFAULT_IDE;
  });

  // Persist to localStorage when IDE changes
  useEffect(() => {
    localStorage.setItem(IDE_STORAGE_KEY, selectedIde);
  }, [selectedIde]);

  const value = {
    selectedIde,
    setSelectedIde
  };

  return (
    <IdeContext.Provider value={value}>
      {children}
    </IdeContext.Provider>
  );
}

export function useIde() {
  const context = useContext(IdeContext);
  if (!context) {
    throw new Error('useIde must be used within an IdeProvider');
  }
  return context;
}

export default IdeContext;
